import { render, staticRenderFns } from "./batchPrintTransferMajor.vue?vue&type=template&id=0387c957&scoped=true&"
import script from "./batchPrintTransferMajor.vue?vue&type=script&lang=js&"
export * from "./batchPrintTransferMajor.vue?vue&type=script&lang=js&"
import style0 from "./batchPrintTransferMajor.vue?vue&type=style&index=0&id=0387c957&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387c957",
  null
  
)

export default component.exports